import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTestimonials, deleteTestimonial, changeActiveStatus } from './testimonialSlice';
import { Container, Modal, Toast, Button } from "react-bootstrap";
import Input from "../../components/input";
import { useNavigate, useLocation } from "react-router-dom";
import CommonButton from "../../components/commonButton";
import CommonPagination from "../../components/commonPagination";
import CommonTable from '../../components/commonTable';
import { Add01Icon } from "../../assets/icons";
import { useLoader } from "../../context/LoaderContext";
import TestimonialAdd from './TestimonialAdd';
import TestimonialEdit from './TestimonialEdit';
import TestimonialView from './TestimonialView';

const TestimonialList = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setLoading } = useLoader();
  const { testimonials } = useSelector((state) => state.testimonials);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedTestimonialId, setSelectedTestimonialId] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const limit = 10;
  const totalPages = Math.ceil(testimonials?.total_records / limit);
  const total = testimonials?.total_records || 0;

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialPage = parseInt(params.get("page") || "1");
  const token = localStorage.getItem('auth-token');

  let testimonialMessage = localStorage.getItem('testimonial_notify_message');

  useEffect(() => {
    if (testimonialMessage) {
      setSnackbarMessage(testimonialMessage);
      setSnackbarVariant("success");
      setShowSnackbar(true);
      localStorage.removeItem('testimonial_notify_message');
    }
  }, [testimonialMessage])

  useEffect(() => {
    const fetchTestimonials = async () => {
      setLoading(true);
      const payload = {
        page: currentPage,
        search: searchTerm,
        limit: limit,
        token
      };
  
      try {
        if (token) {
          await dispatch(getTestimonials({ payload }));
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching testimonials:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchTestimonials();
  }, [dispatch, token, currentPage, searchTerm, setLoading]);
  

  const columns = [
    {label: 'Image', key: 'client_image', type: 'image' },
    { label: 'Name', key: 'client_name' },
    { label: 'Rating', key: 'rating' },
    // { label: 'Address', key: 'client_address' },
    // { label: 'Message', key: 'client_message' },
    { label: 'created at', key: 'created_at', type: 'date' },
    {label: 'Status', key: 'is_active', type: 'status' },
  ];

  const handlePageChange = (newPageNumber) => {
    setCurrentPage(newPageNumber);
    navigate(`/testimonial?page=${newPageNumber}`);
  };

  const handleDeleteNew = async () => {
    if (selectedTestimonialId) {
      await dispatch(deleteTestimonial(selectedTestimonialId)).then((res) => {
        if(res.payload.success) {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("success");
          setShowSnackbar(true);
          const payload = {
            page: currentPage,
            search: searchTerm,
            limit: limit,
            token
          };
          dispatch(getTestimonials({ payload }));
        } else {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("danger");
          setShowSnackbar(true);
        }
      });
    }
  };

  const handleEdit = (row) => {
    // setSelectedTestimonialId(row.id);
    navigate(`/testimonial-edit/${row.id}?page=${currentPage}`);
    // handleOpen();

  };

  // const handleOpen = () => {
  //   setTimeout(() => {
  //     setShowEditModal(true);
  //   }, 1000);
  // };
  

  const handleDelete = (row) => {
    setSelectedTestimonialId(row.id);
    setShowDeleteModal(true);
  };

  const handleView = (row) => {
    setSelectedTestimonialId(row.id);
    setShowViewModal(true);
  };

  const handleStatusChange = async (row) => {
    setSelectedTestimonialId(row.id);
    setShowStatusModal(true);
  }

  const handleStatusChangeNew = async () => {
    await dispatch(changeActiveStatus(selectedTestimonialId)).then((res) => {
      if(res.payload.success) {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("success");
        setShowSnackbar(true);
        const payload = {
          page: currentPage,
          search: searchTerm,
          limit: limit,
          token
        };
        dispatch(getTestimonials({ payload }));
      } else {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("danger");
        setShowSnackbar(true);
      }
    });
  }

    useEffect(() => {
      if (initialPage) {
        setCurrentPage(initialPage);
      }     
    }, [initialPage])

  return (
    <>
      <Container fluid className="px-0">
        <TestimonialAdd 
          show={showModal}
          // onHide={() => setShowModal(false)}
          handleClose={() => setShowModal(false)}
          currentPage={currentPage}
          searchTerm={searchTerm}
          limit={limit}
        />
        <TestimonialEdit
          testimonialId={selectedTestimonialId}
          show={showEditModal}
          // onHide={() => setShowEditModal(false)}
          handleClose={() => setShowEditModal(false)}
          currentPage={currentPage}
          searchTerm={searchTerm}
          limit={limit}
        />
        <TestimonialView
          show={showViewModal}
          handleClose={() => setShowViewModal(false)}
          testimonialId={selectedTestimonialId}
        />

        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this testimonial?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDeleteNew}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Status Update</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to change status?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowStatusModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleStatusChangeNew}>
              Change
            </Button>
          </Modal.Footer>
        </Modal>

        <Toast
          onClose={() => setShowSnackbar(false)}
          show={showSnackbar}
          delay={3000}
          autohide
          bg={snackbarVariant}
          style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
        >
          <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
        </Toast>

        <div className="p-4 d-flex align-items-center justify-content-between gap-4">
          <Input
            type="search"
            value={searchTerm}
            placeholder="Search Testimonial"
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
              navigate(`/testimonials/page=1`);
            }}
            className="shadow-none base-search"
          />

          <CommonButton
            icon={<Add01Icon width={16} height={16} color="#ffffff" strokeWidth="2" />}
            title="Add Testimonial"
            className="btn-primary common-one-shadow"
            onClick={() => {
              // setShowModal(true);
              navigate(`/testimonial-add?page=${currentPage}`);
            }}
          />
        </div>

        <div className="bg-white rounded-2 overflow-hidden common-shadow">
            <CommonTable
              columns={columns}
              data={testimonials?.data || []}
              url={testimonials?.url || []}
              showActions={true}
              actions={{
                showEdit: true,
                showDelete: true,
                showView: false,
                onEdit: handleEdit,
                onDelete: handleDelete,
                onView: handleView
              }}
              onStatusChange={handleStatusChange}
            />
        </div>

        <div className="p-3 mx-1 d-flex flex-wrap align-items-center justify-content-between gap-4">
          <p className="custom-table-infotext">
            Displaying {(limit * (currentPage - 1)) + 1} to {Math.min(limit * currentPage, total)} of {total} Testimonials
          </p>

          <div>
            {totalPages > 1 ? (
              <CommonPagination
                totalItems={total}
                itemsPerPage={limit}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            ) : null}
          </div>
        </div>
      </Container>
    </>
  );
};

export default TestimonialList;
